// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner___EgsK","spinner-sprite":"Spinner_spinner-sprite__MrflN"};